angular.module('filters')

  .filter('initials', function() {
    return function(val) {
      var firstLetters = (val.replace(/[^a-z0-9]/gi, ' ').match(/\b(\w)/g) || []).join('')
      var capitals = firstLetters.replace(/[a-z]/g, '')
      return (capitals || firstLetters).substring(0, 2)
    }
  })
